import { jsx as _jsx } from "react/jsx-runtime";
import { Pill } from '../../pill';
// Replicated from codegen types
export var AppointmentStatus;
(function (AppointmentStatus) {
    AppointmentStatus["PENDING"] = "Pending";
    AppointmentStatus["CONFIRMED"] = "Confirmed";
    AppointmentStatus["COMPLETED"] = "Completed";
    AppointmentStatus["NO_SHOW"] = "No Show";
    AppointmentStatus["CANCELLED"] = "Cancelled";
})(AppointmentStatus || (AppointmentStatus = {}));
export function getStatusVariant(status) {
    // Handle both enum values and string literals for backward compatibility
    const statusValue = typeof status === 'string' ? status : status;
    switch (statusValue) {
        case AppointmentStatus.COMPLETED:
        case 'Completed':
            return 'success';
        case AppointmentStatus.CANCELLED:
        case 'Cancelled':
            return 'error';
        case AppointmentStatus.CONFIRMED:
        case 'Confirmed':
            return 'info';
        case AppointmentStatus.NO_SHOW:
        case 'No Show':
            return 'warning';
        default:
            return 'default';
    }
}
export function StatusCell({ status }) {
    return (_jsx(Pill, { variant: getStatusVariant(status), children: status }));
}
